var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "uploaded-documents-card",
      "store-path": "uploadedFiles",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("client-profile.uploadedFiles"))),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.documents.length
              ? _c(
                  "div",
                  { staticClass: "uploaded-documents-wrapper" },
                  _vm._l(_vm.documents, function (ref, index) {
                    var name = ref.name
                    var applicationId = ref.applicationId
                    var numOfComments = ref.numOfComments
                    var createdAt = ref.createdAt
                    var id = ref.id
                    return _c(
                      "div",
                      {
                        key: id,
                        staticClass: "row",
                        class: !_vm.last(index)
                          ? "column-divider-bottom mb-2 pb-2"
                          : "",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-8 d-flex flex-column justify-content-between",
                          },
                          [
                            _c(
                              "h6",
                              { staticClass: "text-dark-gray bold mb-2" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(name) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "small text-gray mb-0 regular-line-height",
                              },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "client-profile.linkedtoApplicationID"
                                      )
                                    ) + ":"
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(applicationId) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "bold tiny text-uppercase mt-1 followup-tab-content",
                              },
                              [
                                _c("span", { staticClass: "num-comments" }, [
                                  _vm._v(_vm._s(numOfComments)),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(" ") +
                                    _vm._s(_vm.$tc("global.words.comment", 2)) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-4 d-flex flex-column justify-content-between text-right",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-light-gray bold time-ago mb-0",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.formatTimeAgo(createdAt)) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-inline-flex flex-row justify-content-end align-items-center",
                              },
                              [
                                _vm.downloadingDocument[id]
                                  ? _c("inline-loader", { staticClass: "mr-1" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "clickable text-primary download-document view-comment bold",
                                    class: {
                                      disabled: _vm.downloadingDocument[id],
                                    },
                                    attrs: {
                                      docId: id,
                                      fileName: name,
                                      "data-application-id": applicationId,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.handleDownloadDocument(
                                          applicationId,
                                          id,
                                          name
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("global.words.download")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c("img", {
                      attrs: {
                        height: "80px",
                        src: require("@Broker/@Assets/icon/empty-timeline.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("h5", { staticClass: "text-light-gray mt-2" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "client-profile.messages.noDocumentsUploaded"
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]),
                ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }